import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

@injectable()
export class ModalService {
  @observable
  public isOpened = true;

  constructor(private onClose: () => void) {
    makeObservable(this);
  }

  @action
  close = () => {
    this.isOpened = false;
    setTimeout(this.onClose, 200);
  };

  @action
  closeImmediately = () => {
    this.onClose();
  };
}
